module.exports = __webpack_public_path__ + "static/so-3-679b0091fecc8b4b1e88ce9692ce4bf9.png";